import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-3 border-b border-background-200 pb-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="font-label text-xs font-medium uppercase tracking-widest text-primary-600">
            {eyebrow}
          </span>
        )}
        <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl font-body text-sm leading-relaxed text-foreground-600">{description}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap font-label text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-base"></i>
        </Link>
      )}
    </div>
  );
}